import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {BackendApiService} from "../../../services/backend-api.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {AlertService} from "../../../services/alerts.service";
import html2canvas from "html2canvas";

@Component({
    selector: 'app-navbar-suggestion-box',
    templateUrl: './navbar-suggestion-box.component.html',
    styleUrls: ['./navbar-suggestion-box.component.scss'],
})
export class NavbarSuggestionBoxComponent {

    form: FormGroup;
    suggestionBoxVisible = false;

    makeScreenshot: boolean = true;

    isSaving: boolean;

    constructor(
        private elementRef: ElementRef,
        private router: Router,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private backendApiService: BackendApiService
    ) {}

    open(type: string) {
        if (this.suggestionBoxVisible && this.form.value.type != type) {
            this.form.patchValue({type});
            return;
        }

        this.suggestionBoxVisible = !this.suggestionBoxVisible;

        this.form = this.formBuilder.group({
            type: type,
            title: null,
            description: null,
            current_url: window.location.href,
            screenshot: null,
            make_screenshot: true,
        });
    }

    async submitSuggestion() {
        this.isSaving = true;

        const thisComponent = this;

        // without this loading animation will not start until image is generated
        await new Promise(resolve => setTimeout(() => resolve(''), 100));

        if (this.form.value.make_screenshot) {
            try {
                let canvas = await html2canvas(document.body, {
                    // allowTaint: true,
                    // foreignObjectRendering: true
                });

                this.form.patchValue({screenshot: canvas.toDataURL("image/png")});
            } catch (e) {
                console.error('Page screenshot was not generated');
                console.error(e);
            }
        }

        this.backendApiService.post('/suggestions', this.form.value).subscribe({
            next: (response: any) => {
                thisComponent.isSaving = false;
                this.suggestionBoxVisible = false;
                thisComponent.alertService.alertSuccess(response.message);
            },
            error: (err) => {
                thisComponent.isSaving = false;
                thisComponent.alertService.alertError(
                    err.error?.error?.message?.error ||
                    err.error?.error?.message ||
                    err.error?.error ||
                    err.message
                );
            }
        });
    }

    capitalizeFirstLetter(text: string): string {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    @HostListener('document:click', ['$event.target'])
    public onClickOutside(targetElement: HTMLElement): void {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.suggestionBoxVisible = false;
        }
    }
}
